import { render, staticRenderFns } from "./LogoGrid.vue?vue&type=template&id=1397e7de&scoped=true"
import script from "./LogoGrid.vue?vue&type=script&lang=js"
export * from "./LogoGrid.vue?vue&type=script&lang=js"
import style0 from "./LogoGrid.vue?vue&type=style&index=0&id=1397e7de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1397e7de",
  null
  
)

export default component.exports